var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-lines',{staticStyle:{"white-space":"pre-line"},attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }